import { render, staticRenderFns } from "./tabShowDialog.vue?vue&type=template&id=280d8dc0&scoped=true&"
import script from "./tabShowDialog.vue?vue&type=script&lang=js&"
export * from "./tabShowDialog.vue?vue&type=script&lang=js&"
import style0 from "./tabShowDialog.vue?vue&type=style&index=0&id=280d8dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d8dc0",
  null
  
)

export default component.exports